<template>
  <div id="newsCommentComponent">
    <div v-if="item" @click.stop="">
      <div class="newsContent" style="padding-top: 0;" v-if="item.isCommentEnter">
        <div class="commentInput" style="padding-top:0;" v-if="commentKey == 'root'">
          <a-form :form="newsCommentDO">
            <a-form-item style="background-color: #ffffff;margin-bottom: 0;">
              <a-textarea :rows="3" :placeholder="$t('news.editPage.commentTip')" v-decorator="['content',{rules:[
                              {required:true, message:$t('news.editPage.errorInfo.comment')},
                              {min:1,max:256,message:$t('news.editPage.errorInfo.commentLength')}
                              ]}]"></a-textarea>
            </a-form-item>
          </a-form>
          <div class="commentInputBtnRow" style="padding-top:5px;">
            <a-button type="primary" :loading="loading" @click="submitComment" size="small">{{ $t('baseVO.confirm') }}
            </a-button>
            <a-button @click="cancelComment(item)" style="margin-right:10px;" size="small">{{ $t('baseVO.cacel') }}
            </a-button>
          </div>
        </div>
      </div>
      <div class="newsContent" style="padding:5px 0;" v-if="item.commentCount > 0" @click="toggleCommentTree">
        <span v-if="!showCommentTree" class="commentButton">{{ $t('news.unfoldComment') }}</span>
        <span v-else class="commentButton">{{ $t('news.foldComment') }}</span>
        <pt-icon type="icon-zhankai" class="likeIcon"
                 :style="showCommentTree ? {transform: 'rotate(180deg)'} : {}"></pt-icon>
      </div>
      <div class="newsContent" style="padding-top:0;" v-show="showCommentTree">
        <div v-if="commentTree && commentTree.length > 0">
          <div v-for="(item,index) in commentTree" class="commentItem">
            <div>
              <div class="commentItemTop">
                <div class="commentItemTopDiv">
                  <div style="flex: 1">
                    <span class="commentUser">{{ item.tree.createName }}</span>
                    <span style="margin: 0 4px;">:</span>
                    <span class="commentContent">{{ item.tree.content }}</span>
                  </div>
                  <!--                  <div class="commentUser">{{item.tree.createName}}:</div>-->
                  <!--                  <div class="commentContent" style="flex: 1;">{{item.tree.content}}</div>-->
                  <div class="commentIconDiv" style="display: flex;justify-items: end">
                    <div @click="changeCommentKey(index)">
                      <pt-icon type="icon-pinglun" :title="$t('keypinglun')" class="commentIcon"></pt-icon>
                    </div>
                    <div style="margin-left: 10px;" v-if="item.tree.createrId  == userInfo.accountDO.id"
                         @click="deleteComment(item.tree.id)">
                      <pt-icon type="icon-tubiao" :title="$t('baseVO.delete')"></pt-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="commentKey == index" style="margin-left: 10px;margin-top: 10px;">
                <a-form :form="form">
                  <a-form-item style="background-color: #ffffff;">
                    <a-textarea :rows="3" :placeholder="$t('news.editPage.commentTip')" v-decorator="['content',{rules:[
                              {required:true, message:$t('news.editPage.errorInfo.comment')},
                              {min:1,max:256,message:$t('news.editPage.errorInfo.commentLength')}
                              ]}]"></a-textarea>
                  </a-form-item>
                </a-form>
                <div class="commentInputBtnRow">
                  <a-button type="primary" :loading="loading" @click="submitCommentOnComment(item.tree)" size="small">
                    {{ $t('baseVO.confirm') }}
                  </a-button>
                  <a-button @click="cancelComment" style="margin-right:10px;" size="small">{{ $t('baseVO.cacel') }}
                  </a-button>
                </div>
              </div>
              <div v-if="item.children && item.children.length > 0" class="innerCommentDiv">
                <div v-for="(innerItem,innerIndex) in item.children">
                  <div class="innerItemTop">
                    <div class="innerItemLeft">
                      <span class="innerUser">{{ innerItem.tree.createName }}</span>
                      <span class="innerReplyText">{{ $t('news.editPage.reply') }}</span>
                      <span class="innerUser">{{ innerItem.tree.toUserName }}</span>
                      <span style="margin: 0 4px;">:</span>
                      <span class="innerText">{{ innerItem.tree.content }}</span>
                    </div>
                    <div class="innerItemRight" style="display: flex;justify-items: end">
                      <div style="padding-right: 12px" v-if="innerItem.tree.createrId  == userInfo.accountDO.id"
                           @click="deleteComment(innerItem.tree.id)">
                        <pt-icon type="icon-tubiao" :title="$t('baseVO.delete')"></pt-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newsCommentApi from '@/api/mine/newsComment'
import {mapState} from 'vuex'
import UserApi from "@/api/sys/user";

export default {
  name: 'newsCommentComponent',
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      loading: false,
      item: null,
      formToken: '',
      commentTree: [],
      showCommentTree: false,
      isCommentEnter: false,
      newsCommentDO: this.$form.createForm(this, {}),
      form: this.$form.createForm(this, {}),
      commentKey: 'root',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info
    }),
  },
  mounted() {

  },
  methods: {
    initFormToken() {
      UserApi.getFormToken().then(res => {
        if (res.code == 1) {
          this.formToken = res.data;
        }
      })
    },
    init() {
      this.initFormToken();
    },
    toggleCommentTree() {
      this.initCommentList().then(() => {
        this.showCommentTree = !this.showCommentTree
      })
    },
    toggleCommentInput() {
      this.commentKey = 'root';
    },
    deleteComment(id) {
      newsCommentApi.deleteById(id).then(res => {
        if (res.code == 1) {
          // this.$emit('delete')
          this.initCommentList()
          this.$message.success("删除成功");
        }
      })
    },
    submitCommentOnComment(treeNode) {
      this.loading = true;
      this.form.validateFields(err => {
        if (!err) {
          let curForm = this.form.getFieldsValue();
          let node = {newsId: this.item.id, parentId: treeNode.id, content: curForm.content, formToken: this.formToken}
          newsCommentApi.insert(node).then(res => {
            this.loading = false;
            if (res.code == 1) {
              this.$message.success(res.message)
              this.commentKey = null
              this.initCommentList()
              this.initFormToken();
              this.showCommentTree = true;
              this.$emit('saveSuccess', this.item)
            } else {
              this.initFormToken();
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          })
        } else {
          this.loading = false;
        }
      })
    },
    submitComment(item) {
      this.loading = true;
      this.newsCommentDO.validateFields(err => {
        if (!err) {
          let newsCommentDO = this.newsCommentDO.getFieldsValue()
          newsCommentDO.newsId = this.item.id
          newsCommentDO.formToken = this.formToken
          newsCommentApi.insert(newsCommentDO).then(res => {
            this.loading = false;
            if (res.code == 1) {
              this.$message.success(res.message)
              this.commentKey = null
              this.initCommentList()
              this.initFormToken();
              this.showCommentTree = true;
              this.$emit('saveSuccess', this.item);
              this.cancelComment(item)
            } else {
              this.initFormToken();
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          })
        } else {
          this.loading = false;
          console.log("提交失败")
        }
      })
    },
    cancelComment(item) {
      if (item) {
        this.$emit('cancelComment', item)
      }
      this.commentKey = null;
    },
    changeCommentKey(index, type) {
      if (type == 'inner') {
        if (this.commentKey == 'inner' + index) {
          this.commentKey = null;
        } else {
          this.commentKey = 'inner' + index;
        }
      } else {
        if (this.commentKey == index) {
          this.commentKey = null;
        } else {
          this.form = this.$form.createForm(this, {})
          this.commentKey = index;
        }
      }
    },
    initCommentList() {
      let this_ = this
      let p = new Promise((resolve, reject) => {
        newsCommentApi.selectByNewsId(this.item.id).then(res => {
          if (res.code == 1) {
            this_.commentTree = res.data != null ? res.data.children : null
            resolve()
          } else {
            reject()
          }
        })
      })
      return p
    },
  },
  watch: {
    'item.isCommentEnter'() {
      this.init();
      this.toggleCommentInput()
    }
  }
}
</script>

<style scoped lang="less">
#newsCommentComponent {
  padding: 0 20px 20px 20px;
  background: rgba(244, 245, 248, 0.6);

  .newsContent {
    word-break: break-all;
    overflow-wrap: break-word;
    /*padding: 20px;*/
    border-radius: 0 0 5px 5px;
    font-size: 14px;
    color: #323232;
    letter-spacing: 1px;
    text-align: justify;
    line-height: 24px;
    word-wrap: break-word;
  }

  .commentInputBtnRow {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 20px;
  }

  .commentButton {
    font-size: 14px;
    color: #527695;
  }

  .likeIcon {
    cursor: pointer;
    font-size: 10px;
    margin-left: 5px;
  }

  .commentItemTop {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;

    .commentItemTopDiv {
      display: flex;
      flex-direction: row;
      /*align-items: center;*/
      margin-right: 10px;
      flex: 1;
    }

    .commentContent {
      word-break: break-all;
      word-wrap: break-word;
    }

    .commentIconDiv {
      width: 40px;
      text-align: right;

      .commentIcon {
        font-size: 14px;
        cursor: pointer;
      }

      .commentIcon:hover {
        transform: scale(1.2);
      }
    }

    .commentUser {
      font-size: 14px;
      color: #188BE3;
    }

    .commentTime {
      font-size: 14px;
      color: #909090;
      margin-right: 40px;
    }
  }

  .innerCommentDiv {
    /*padding-left: 10px;*/
  }

  .innerItemTop {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .innerItemLeft {
    flex: 1;

    .innerUser {
      font-size: 14px;
      color: #188BE3;
      line-height: 24px;
    }

    .innerReplyText {
      margin: 0 10px;
      font-size: 14px;
      line-height: 24px;
      color: #333333;
    }

    .innerText {
      font-size: 14px;
      color: #323232;
      line-height: 24px;
    }
  }

  .innerItemRight {
    width: 48px;
    justify-content: flex-end;
  }
}
</style>